import type { SxProps } from '@mui/material';
import type {
  LineItemFragmentFragment,
  WishlistLineItemsFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import type { ProductPriceProps } from '@packages/shared';
import { ProductPrice, Grid } from '@packages/shared';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { defineMessages, useIntl } from 'react-intl';
import { isCartPrice } from '../../utils/typeguards';

const messages = defineMessages({
  uvp: {
    defaultMessage: 'UVP:',
    id: 'ProductPriceWrapper.uvp',
  },
  saving: {
    defaultMessage: 'statt',
    id: 'ProductPriceWrapper.saving',
  },
});
const ProductPriceContainer = (alignmentOverride?: ProductPriceProps['alignment']): SxProps => ({
  maxWidth: { xs: '100%' },
  flexShrink: 1,
  flexDirection: 'column',
  alignItems: alignmentOverride === 'left' ? 'flex-start' : 'flex-end',
  pb: '0.983rem',
  width: 'auto',
  minWidth: 'max-content',
});
export const ProductPriceWrapper: React.FC<{
  price: LineItemFragmentFragment['price'] | WishlistLineItemsFragmentFragment['price'];
  isSoldOut: LineItemFragmentFragment['isSoldOut'] | WishlistLineItemsFragmentFragment['isSoldOut'];
  alignmentOverride?: ProductPriceProps['alignment'];
}> = ({ price, isSoldOut, alignmentOverride }) => {
  const { isMobile } = useDeviceType();
  const { formatMessage } = useIntl();

  return (
    <Grid container sx={{ ...ProductPriceContainer(alignmentOverride) }}>
      {!isSoldOut && price !== null && (
        <ProductPrice
          fontVariantPrice={isMobile ? 'h6' : 'h5'}
          currency={price.currency}
          isStartPrice={price.isStartPrice || undefined}
          oldPrice={price.valueOld || undefined}
          unit={price.unit || undefined}
          unitPrice={price.valueUnit || undefined}
          price={price.value}
          discountType={
            price.saving?.type?.toLowerCase() as Lowercase<
              NonNullable<LineItemFragmentFragment['price']['saving']>['type']
            >
          }
          saving={price.saving?.value || undefined}
          hasDiscountFlag={isCartPrice(price) ? !price.discount : price?.saving?.value !== 0}
          alignment={alignmentOverride ?? 'right'}
          uvpLabel={
            price.uvp
              ? formatMessage(messages.uvp)
              : (price.saving !== null && formatMessage(messages.saving)) || undefined
          }
          displayNegativeDiscountNumber
        />
      )}
    </Grid>
  );
};
